var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSubDirectory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 6a1 1 0 011 1v4h18.585l-3.292-3.293a.999.999 0 111.414-1.414l4.991 4.992c.032.03.062.063.09.098l-.081-.09a1.005 1.005 0 01.293.674v.066l-.003.052L24 12a1.007 1.007 0 01-.302.715l-4.991 4.992a.997.997 0 01-1.414 0 .999.999 0 010-1.414L20.585 13H1a1 1 0 01-1-1V7a1 1 0 011-1z",
    fill: "#222",
    fillRule: "evenodd",
    className: "fi-icon-base-fill"
  })));
}

export default SvgIconSubDirectory;